import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableAudienceBuilderWrap = Loadable({
  loader: function loader() {
    return import('../Audiences/AudienceBuilderWrap.jsx');
  },
  loading: ComponentLoading
});
export default LoadableAudienceBuilderWrap;